require("./page.scss");
import { MediaManager } from '../../Shared/Assets/media-assets.js';
import { AdvertPlatform } from '../../AdvertPlatform/Assets/advertplatform-assets.js';

class ContentHub {
    init() {
        this.initProperties();
        this.advertPlatform.loadAdverts();
        this.mediaManager.updateMedia();
    }

    initProperties = () => {
        this.mediaManager = new MediaManager();
        this.advertPlatform = new AdvertPlatform();
    }

    onResize = () => {
        if(this.mediaManager)
            this.mediaManager.onResize();
    }
}

const contentHub = new ContentHub();

window.addEventListener("load", () => contentHub.init());

window.addEventListener("resize", () => contentHub.onResize());
